import axios from "axios";
import { server } from "../../server";

// create product
export const createProduct = (newForm) => async (dispatch) => {
  try {
    dispatch({
      type: "productCreateRequest",
    });

    const config = { headers: { "Content-Type": "multipart/form-data" } };

    const { data } = await axios.post(
      `${server}/product/create-product`,
      newForm,
      config,
    );
    dispatch({
      type: "productCreateSuccess",
      payload: data.product,
    });
  } catch (error) {
    dispatch({
      type: "productCreateFail",
      payload: error.response.data.message,
    });
  }
};

// get All Products of a shop
export const getAllProductsShop = (id) => async (dispatch) => {
  try {
    dispatch({
      type: "getAllProductsShopRequest",
    });

    if (
      !id ||
      id === "null" ||
      id === "undefined" ||
      !/^[a-fA-F0-9]{24}$/.test(id)
    ) {
      dispatch({
        type: "getAllProductsShopSuccess",
        payload: [],
      });
      return;
    }

    const { data } = await axios.get(
      `${server}/product/get-all-products-shop/${id}`,
    );
    dispatch({
      type: "getAllProductsShopSuccess",
      payload: data.products,
    });
  } catch (error) {
    dispatch({
      type: "getAllProductsShopFailed",
      payload: error.response.data.message,
    });
  }
};

// delete product of a shop
export const deleteProduct = (id) => async (dispatch) => {
  try {
    dispatch({
      type: "deleteProductRequest",
    });

    const { data } = await axios.delete(
      `${server}/product/delete-shop-product/${id}`,
      {
        withCredentials: true,
      },
    );

    dispatch({
      type: "deleteProductSuccess",
      payload: {
        message: data.message,
        productId: id,
      },
    });
  } catch (error) {
    dispatch({
      type: "deleteProductFailed",
      payload: error.response.data.message,
    });
  }
};

// update product of a shop
export const updateProduct = (id, productData) => async (dispatch) => {
  try {
    dispatch({
      type: "updateProductRequest",
    });

    const config = { headers: { "Content-Type": "multipart/form-data" } };

    const { data } = await axios.put(
      `${server}/product/update-shop-product/${id}`,
      productData,
      {
        withCredentials: true,
        ...config,
      },
    );

    dispatch({
      type: "updateProductSuccess",
      payload: data.product,
    });
  } catch (error) {
    dispatch({
      type: "updateProductFailed",
      payload: error.response.data.message,
    });
  }
};

// get all products
export const getAllProducts = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAllProductsRequest",
    });

    const { data } = await axios.get(`${server}/product/get-all-products`);
    dispatch({
      type: "getAllProductsSuccess",
      payload: data.products,
    });
  } catch (error) {
    dispatch({
      type: "getAllProductsFailed",
      payload: error.response.data.message,
    });
  }
};

// get single product
export const getSingleProduct = (id) => async (dispatch) => {
  try {
    dispatch({
      type: "getSingleProductRequest",
    });

    const { data } = await axios.get(`${server}/product/get-product/${id}`);
    dispatch({
      type: "getSingleProductSuccess",
      payload: data.product,
    });
  } catch (error) {
    dispatch({
      type: "getSingleProductFailed",
      payload: error.response.data.message,
    });
  }
};

// clear success state
export const clearSuccess = () => async (dispatch) => {
  dispatch({
    type: "clearSuccess",
  });
};
